import { RawCompanyData } from '@company/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ADD_COMPANY_ENTITY } from '../company-state';

export const ADD_COMPANY = '[Company] Add Company';
export const ADD_COMPANY_AUTH_CHECK_SUCCESS = '[Company] Add Company Auth Check Success';
export const ADD_COMPANY_DUPLICATE_CHECK_SUCCESS = '[Company] Add Company Duplicate Check Success';
export const ADD_COMPANY_COUNT_CHECK_SUCCESS = '[Company] Add Company Count Check Success';
export const ADD_COMPANY_SUCCESS = '[Company] Add Company Success';
export const ADD_COMPANY_FAIL = '[Company] Add Company Fail';
export const RESET_ADDED_COMPANY = '[Company] Reset Added Company';

export class AddCompany extends StateUtils.LoaderLoadAction {
  readonly type = ADD_COMPANY;

  constructor(public payload: RawCompanyData) {
    super(ADD_COMPANY_ENTITY);
  }
}

export class AddCompanyAuthCheckSuccess implements Action {
  readonly type = ADD_COMPANY_AUTH_CHECK_SUCCESS;

  constructor(public payload: RawCompanyData) {}
}

export class AddCompanyDuplicateCheckSuccess implements Action {
  readonly type = ADD_COMPANY_DUPLICATE_CHECK_SUCCESS;

  constructor(public payload: RawCompanyData) {}
}

export class AddCompanyCountCheckSuccess implements Action {
  readonly type = ADD_COMPANY_COUNT_CHECK_SUCCESS;

  constructor(public payload: RawCompanyData) {}
}

export class AddCompanySuccess extends StateUtils.LoaderSuccessAction {
  readonly type = ADD_COMPANY_SUCCESS;

  constructor(public payload: string) {
    super(ADD_COMPANY_ENTITY);
  }
}

export class AddCompanyFail extends StateUtils.LoaderFailAction {
  readonly type = ADD_COMPANY_FAIL;

  constructor(public payload?: RawCompanyData) {
    super(ADD_COMPANY_ENTITY);
  }
}

export class ResetAddedCompany extends StateUtils.LoaderResetAction {
  readonly type = RESET_ADDED_COMPANY;

  constructor() {
    super(ADD_COMPANY_ENTITY);
  }
}

export type AddCompanyActions =
  | AddCompany
  | AddCompanyAuthCheckSuccess
  | AddCompanyDuplicateCheckSuccess
  | AddCompanyCountCheckSuccess
  | AddCompanySuccess
  | AddCompanyFail
  | ResetAddedCompany;
